export default "/images/newsletter.png?d6f3423608f9cf955abe5887f697b924";